import { render, staticRenderFns } from "./SlotsGameFrame.vue?vue&type=template&id=52850ab8&scoped=true"
import script from "./SlotsGameFrame.vue?vue&type=script&lang=js"
export * from "./SlotsGameFrame.vue?vue&type=script&lang=js"
import style0 from "./SlotsGameFrame.vue?vue&type=style&index=0&id=52850ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52850ab8",
  null
  
)

export default component.exports